export const ORDER_DETAILS_SIDEBAR_TRANSLATION_EN = {
  order_details: 'Order details',
  open_planning: 'Open planning',
};
